/**
 * Trace to Playwright Test Generator (Re-export for backwards compatibility)
 *
 * This file now re-exports from the modularized playwright-generator folder.
 * New code should import directly from './playwright-generator' instead.
 *
 * @deprecated Import from './playwright-generator' instead
 */

// Re-export everything from the modularized playwright-generator
export * from "./playwright-generator";

// Also re-export types from trace-inspector for backwards compatibility
// (some consumers may have been importing MachineTrace/TraceEvent from this file)
export type { MachineTrace, TraceEvent } from "./trace-inspector";
